import { axios } from '@/utils/request'
/**
 * api接口列表
 */
 const apiPath = {
    list: '/api/v1/pms/web/project/notice/search',
    add: '/api/v1/pms/web/project/notice/send',
    edit: '/api/v1/pms/web/project/item/modify',
    detail: '/api/v1/pms/web/project/notice/detail',
    delete: '/api/v1/pms/web/project/notice/delete',
    readAll: '/api/v1/pms/web/project/notice/readAll'
 }

 /**
 * 消息列表
 * @param {*} data
 */
  export function list (data) {
    return axios({
      url: apiPath.list,
      method: 'post',
      data
    })
  }
/**
 * 添加消息
 * @param {*} data
 */
 export function add (data) {
    return axios({
      url: apiPath.add,
      method: 'post',
      data
    })
  }

/**
 * 编辑消息
 * @param {*} data
 */
 export function edit (data) {
  return axios({
    url: apiPath.edit,
    method: 'post',
    data
  })
}
/**
 * 获取消息详情
 * @param {*} data
 */
export function detail (userNoticeId) {
  return axios({
    url: apiPath.detail,
    method: 'get',
    params: { userNoticeId }
  })
}

/**
 * 删除消息
 * @param {*} data
 */
 export function deleteMessage (noticeId) {
  return axios({
    url: apiPath.delete,
    method: 'get',
    params: { noticeId }
  })
}

/**
 * 全部标记未已读
 * @param {*} data
 */
 export function readAll (data) {
  return axios({
    url: apiPath.readAll,
    method: 'post',
    data
  })
}

